<template>
  <IonItem class="inline-readonly-item" lines="full" :color="gray ? 'whitesmoke' : 'white'">
    <IonLabel color="light" class="font-medium truncate">
      <div class="flex items-center">
        <div class="flex justify-center" :class="icon ? 'w-10 min-w-10' : 'w-5 min-w-5'">
          <i
            v-if="icon"
            :class="{ [icon]: true, 'text-blue-500': iconColor === 'blue', 'text-gray-500': iconColor === 'gray' }"
          ></i>
        </div>
        <span>{{ label }}</span>
      </div>
    </IonLabel>
    <div slot="end">
      <IonSkeletonText
        v-if="loading"
        class="h-6 rounded-lg"
        :animated="true"
        :class="{
          'w-10': skeletonSize === 'xs',
          'w-16': skeletonSize === 'sm',
          'w-24': skeletonSize === 'md',
          'w-32': skeletonSize === 'lg',
          'w-40': skeletonSize === 'xl',
        }"
      />
      <div v-else-if="!!onClick" class="text-blue-500 font-medium text-right" @click="onClick()">
        <i v-if="!value" class="icon-minus text-2xl mr-2 text-gray-500"></i>
        {{ value }}
        <div class="ml-auto text-sm w-fit font-light" v-if="subValue">{{ subValue }}</div>
      </div>
      <div v-else class="text-gray-700 font-medium text-right">
        <i v-if="!value" class="icon-minus text-2xl mr-2 text-gray-500"></i>
        {{ value }}
        <div class="ml-auto text-sm w-fit font-light" v-if="subValue">{{ subValue }}</div>
      </div>
    </div>
  </IonItem>
</template>

<script setup lang="ts">
import { IonItem, IonLabel, IonSkeletonText } from '@ionic/vue';

withDefaults(
  defineProps<{
    label: string;
    value?: string;
    subValue?: string;
    onClick?: () => void;
    icon?: string;
    iconColor?: 'blue' | 'gray';
    gray?: boolean;
    loading?: boolean;
    skeletonSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  }>(),
  { skeletonSize: 'md', iconColor: 'blue' }
);
</script>

<style scoped>
ion-item.inline-readonly-item::part(native) {
  --border-width: 1px;
}

ion-item.inline-readonly-item {
  --inner-padding-top: 8px;
  --inner-padding-bottom: 8px;
  --inner-padding-start: 0px;
  --padding-start: 0px;
}
</style>
